import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';

export const INITIAL_STATE = Immutable({
    isAuthenticated: false,
    error: false,
    errorCode: null,
    message: null,
    isLoading: false
});



const response = (state, action) => {
    if (action.response.ok)
      return state.merge({
        isAuthenticated: true,
        error: false,
        errorCode: null,
        message: action.response.message
      })
    else if (action.response.error) {
      return state.merge({
        isAuthenticated: false,
        error: true,
        errorCode: action.response.errorCode,
        message: action.response.message
      })
    }
    else {
      return state.merge({
        isAuthenticated: false,
        error: false,
        errorCode: null,
        message: null
      })
    }  
}

const setLoader = (state, action) => {
  return state.merge({
    isLoading: true,
    message: action.message
  })
}

const unsetLoader = (state) => {
  return state.merge({
    isLoading: false,
    message: null
  })
}

const ACTION_HANDLERS = {
    [Types.LOGIN_RESPONSE]: response,
    [Types.SET_LOADER]: setLoader,
    [Types.UNSET_LOADER]: unsetLoader
};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)